import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import WeddingHome from "@/pages/WeddingHome";
import AdminRsvp from "@/pages/AdminRsvp";
import Inspiration from "@/pages/Inspiration";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WeddingHome />} />
            <Route path="/inspiration" element={<Inspiration />} />
            <Route path="/admin" element={<AdminRsvp />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#FAFAFA",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 0,
              fontFamily: "'Manrope', sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
